import React, { PureComponent } from "react"
import * as i18n from "tb-i18n"
import "tb-icons/lib/styles/tb-icons.css"
import { getGlobalConfig } from "../../../lib/global-config"
import { ProductsMatrixDataType } from "../homepage.module"

const styles = require("./mobile-panel.styl")

interface Props
    extends Pick<
        ProductsMatrixDataType,
        | "title"
        | "subtitle"
        | "icon"
        | "themeColor"
        | "fontImage"
        | "enFontImage"
        | "isWIP"
        | "link"
        | "backgroundLinear"
    > {}

export default class ProductMatrix extends PureComponent<Props> {
    constructor(prop) {
        super(prop)
        this.state = {
            currentIndex: 0,
            direction: "up"
        }
    }
    render() {
        const {
            icon,
            fontImage,
            enFontImage,
            title,
            subtitle,
            themeColor,
            backgroundLinear,
            link
        } = this.props
        const backStyle = {
            background: `linear-gradient(180deg, ${backgroundLinear[0]}, ${
                backgroundLinear[1]
            })`
        }
        const image = getGlobalConfig().lang === "en" ? enFontImage : fontImage
        return (
            <div className={ styles["product-mobile-panel"] }>
                <a
                    className="product-mobile-panel-bar"
                    href={ link ? link : "javascript:void(0);" }
                >
                    <div
                        className="product-mobile-panel-bar-icon"
                        style={{ backgroundImage: `url(${icon})` }}
                    />
                    <div className="product-mobile-panel-bar-text">
                        <div className="product-mobile-panel-bar-text-title">
                            {title}
                            {this.renderTip()}
                        </div>
                        <div className="product-mobile-panel-bar-text-subtitle">
                            {subtitle}
                        </div>
                    </div>
                    <div
                        className="product-mobile-panel-bar-arrow"
                        style={{ color: themeColor }}
                    >
                        {this.renderRightArrow()}
                    </div>
                </a>

                <div className="product-mobile-panel-image" style={ backStyle }>
                    <div
                        className="product-mobile-panel-image-font"
                        style={{ backgroundImage: `url(${image})` }}
                    />
                </div>
            </div>
        )
    }
    renderRightArrow() {
        const { isWIP } = this.props
        if (isWIP) {
            return null
        }
        return <span className="icon icon-chevron-right" />
    }
    renderTip() {
        const { isWIP } = this.props
        if (isWIP) {
            return (
                <span className="product-mobile-panel-bar-text-title-tip">
                    {i18n.get("homepage.comingSoon")}
                </span>
            )
        }
    }
}
